import { useContext } from 'react';
import { RRule } from 'rrule';
import { Menu } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTextInput } from '@shared/components/textInput';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { MonthOptions } from './MonthOptions';
import { WeekOptions } from './WeekOptions';
import { YearOptions } from './YearOptions';
import { useCustomBatch } from './hooks/useCustomBatch';

export function CustomBatchMobile({
  rruleOptions,
  setRruleOptions,
  setUserIsEditing,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions' | 'setUserIsEditing'>) {
  const colors = useContext(ColorThemeContext);

  const { frequencyLabel, interval, freqOptions, handleIntervalChange } = useCustomBatch({
    rruleOptions,
    setRruleOptions,
    setUserIsEditing,
  });

  return (
    <>
      <Text size="body1" weight="semibold">
        {i18n('workflowTemplate.component.dateAndRepeat.every')}
      </Text>
      <View
        row
        centerVertically
        style={{
          width: '100%',
          justifyContent: 'flex-start',
        }}
        gap={1}
        marginVertical={1.5}
      >
        <MBIconV2 name="repeat" size={35} color={colors.accent} />
        <MBTextInput
          value={String(interval ?? '')}
          onChangeText={handleIntervalChange}
          noPadding
          style={{
            width: grid(6.5),
            paddingHorizontal: grid(2),
            backgroundColor: Colors.v2.backgroundGrayLight,
            borderWidth: 0,
          }}
        />
        <Menu>
          <Menu.Button label={frequencyLabel} flex />
          <Menu.Content>
            {freqOptions.map((opt, i) => (
              <Menu.Item
                key={i}
                label={opt.title}
                onClick={() => {
                  opt.onPress();
                }}
              />
            ))}
          </Menu.Content>
        </Menu>
      </View>
      {rruleOptions?.freq === RRule.WEEKLY && (
        <WeekOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.MONTHLY && (
        <MonthOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.YEARLY && (
        <YearOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
    </>
  );
}
